<div class="modal-header">
  <h5 class="card-title" i18n>Order details</h5>
  <button type="button" class="btn-close" (click)="activeModal.close()"></button>
</div>
<div *ngIf="shift" class="modal-body">
  <h5 i18n>Details</h5>
  <table class="table table-borderless table-sm w-auto">
    <tbody>
      <tr>
        <th i18n>ID:</th>
        <td>{{ shift.id | number }}</td>
      </tr>
      <tr>
        <th i18n>Type:</th>
        <td>{{ shift.type | i18nSelect: shiftTypes }}</td>
      </tr>
      <tr>
        <th i18n>Created at:</th>
        <td>{{ shift.created_at | date: 'short' }}</td>
      </tr>
      <tr *ngIf="shift.confirmed_employee">
        <th i18n>Confirmed by partner</th>
        <td></td>
      </tr>
      <tr>
        <th i18n>Order start time:</th>
        <td>{{ shift.start | date: 'short' }}</td>
      </tr>
      <tr>
        <th i18n>Order end time:</th>
        <td>{{ shift.end | date: 'short' }}</td>
      </tr>
      <tr *ngIf="shift.checkin_start">
        <th i18n>Work start time:</th>
        <td>{{ shift.checkin_start | date: 'short' }}</td>
      </tr>
      <tr *ngIf="shift.checkin_end">
        <th i18n>Work end time:</th>
        <td>{{ shift.checkin_end | date: 'short' }}</td>
      </tr>
    </tbody>
  </table>
  <h5 i18n>Items</h5>
  <table class="table">
    <thead>
      <tr>
        <th i18n>Item</th>
        <th i18n class="text-end">Price</th>
        <th i18n class="text-end">Subtotal</th>
        <th i18n class="text-end">Discount</th>
        <th i18n class="text-end">VAT</th>
        <th i18n class="text-end">Total</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let invoicable of shift.invoicables">
      <tr>
        <td class="align-middle">{{ invoicable | translateField: 'title' }}</td>
        <td class="text-end align-middle">
          <ng-container *ngIf="invoicable.number > 1">{{ invoicable.number | number:'1.0-2' }} x</ng-container>
          {{ invoicable.amount | currency: organization.currency }}
        </td>
        <td class="text-end align-middle">{{ invoicable.subtotal | currency: organization.currency }}</td>
        <td class="text-end align-middle">{{ invoicable.discount | currency: organization.currency }}</td>
        <td class="text-end align-middle">{{ invoicable.total_tax | currency: organization.currency }}</td>
        <td class="text-end align-middle">{{ invoicable.total | currency: organization.currency }}</td>
      </tr>
    </ng-container>
    </tbody>
    <tfoot>
      <tr>
        <th colspan="5" i18n>Total</th>
        <th class="text-end">{{ shift.total_invoicable | currency: organization.currency }}</th>
      </tr>
    </tfoot>
  </table>
  <p *ngIf="shift.discount_percent > 0" class="text-success">
    {{ shift.discount_percent | number: '1.0-2' }}%&nbsp;<span i18n>discount included</span>
  </p>
  <p *ngIf="shift.refund > 0" class="text-success">
    {{ shift.refund | number: '1.0-2' }}%&nbsp;<span i18n>refund included</span>
  </p>
  <ng-container *ngIf="shift.customer_contact_card_id">
    <h5 i18n>Payment</h5>
    <span i18n>Card: </span>
    {{ shift.customer_contact_card.number }}
    <ng-container i18n>expires</ng-container>
    {{ shift.customer_contact_card.expire_month | number: '2.0-0' }}/{{
    shift.customer_contact_card.expire_year }}
  </ng-container>
</div>
<div class="modal-footer text-end">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>